import {page} from '@commercial-website/analytics'
import {hasAdvertisingConsent} from '@commercial-website/consent'
import {pushEvent} from '@commercial-website/observability'
import type {GatsbyBrowser} from 'gatsby'

import {queueParamCookies} from '@/config/param-cookies'
import {updateSessionTrackingCookies} from '@/utils/track-session'

export const onRouteUpdate: GatsbyBrowser['onRouteUpdate'] = ({location}) => {
    if (location.search) {
        queueParamCookies(new URLSearchParams(location.search))
    }

    if (hasAdvertisingConsent()) {
        updateSessionTrackingCookies()
    }

    // The page path without the locale segment, e.g. `/pricing` instead of `/en/pricing`
    const rawPath = `/${location.pathname.split('/').slice(2).join('/')}`

    page({
        rawPath,
    })

    pushEvent('navigation', {
        url: location.pathname,
    })
}
